import { useState } from 'react';
import type { User } from '../api/types';
import { colorFor, initials } from '../lib/avatar';

export function Avatar({ user, size = 44 }: { user: Pick<User, 'id' | 'displayName' | 'avatarUrl'> | null; size?: number }) {
  const [failed, setFailed] = useState<string | null>(null);
  if (!user) return <div className="avatar" style={{ width: size, height: size }} />;
  const showImage = user.avatarUrl && failed !== user.avatarUrl;
  return (
    <div
      className="avatar"
      style={{ width: size, height: size, fontSize: size * 0.4, background: showImage ? undefined : colorFor(user.id) }}
      aria-label={user.displayName}
    >
      {showImage ? (
        <img src={user.avatarUrl!} alt="" loading="lazy" onError={() => setFailed(user.avatarUrl)} />
      ) : (
        initials(user.displayName)
      )}
    </div>
  );
}
